export function newDiv(text, parent, options = {}) {
  const { append = 'end' } = options;
  const res = document.createElement('div');

  if (text) {
    if (text instanceof Element || text instanceof HTMLDocument) {
      res.appendChild(text);
    } else {
      res.innerText = text;
    }
  }
  if (parent) {
    switch (append) {
      case 'begin':
        parent.insertBefore(res, parent.firstElementChild);
        break;
      case 'end':
        parent.appendChild(res);
        break;
      default:
        parent.appendChild(res);
    }
  }
  return res;
}

export function prepareEvent(e) {
  if (e) {
    if (e.preventDefault) e.preventDefault();
    if (e.stopPropagation) e.stopPropagation();
    e.cancelBubble = true;
    e.returnValue = false;
  }
}

export function isLeft(e) {
  if (e.which) {
    return e.which === 1;
  }

  return e.button ? e.button === 0 : false;
}

export const createImage = (src) => {
  const img = document.createElement('img');
  img.src = src;
  return img;
};
